import { DOMHelper } from "../Helpers/DOMHelper.js";
import { DealPage } from "./DealPage.js";
import { Modal } from "./Modal.js";

export class ThankYouModal {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = "start-submission-modal";
    }

    init() {
        var $this = this;
        this.submissionModal = new Modal(
            this.app,
            "start-submission-container",
            this.getHtml(),
            null,
            "submission-class"
        );
        this.submissionModal.init();
        // Fires on every path that hides this modal, including the background-curtain
        // click handled inside Modal.js itself (mousedown/mouseup on ".pm-drs-modal") —
        // not just the Continue/X buttons below. Before this, curtain-click only hid the
        // thank-you modal and left the DealPage modal stuck open underneath; routing the
        // full close+reset through here (instead of duplicating it in eventHandlers) keeps
        // every dismissal path in sync going forward.
        this.submissionModal.setHideCallback(()=>{
            $this.app.adobeDtmDatalayer.fireEvent('buttonClick', {btnText:'summary-confirmation-overlay-close'});
            $this.closeDealAndReset();
        });
        this.eventHandlers();
        this.addSubmissionFormImg();
        this.hideImage();
    }

    setBackground(make) {
        let background = make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        DOMHelper.addClass(document.querySelector(this.app.getSelector("#close-form-submission")), background);
    }

    closeDealAndReset() {
        this.app.dealModal.hide();
        document.querySelector("body").style.setProperty("position", "inherit", "important");
        this.resetDrsForm();
    }

    eventHandlers() {
        let $this = this;

        // Hiding the submission modal here is what triggers closeDealAndReset (via
        // setHideCallback in init()) — closes the whole DRA and resets it, so a later
        // reopen starts fresh (with contact info prefilled, see
        // ContactFormSection.prefillFromStoredContactInfo — not blocked from
        // resubmitting).
        let backButtonEvent = function () {
            $this.submissionModal.hide();
        };

        let button = document.querySelector($this.app.getSelector("#submit-another-drs"));//remove ids
        button.addEventListener("click", backButtonEvent);

        let closeBtn = document.querySelector($this.app.getSelector("#close-form-submission"));//remove ids
        closeBtn.addEventListener("click", backButtonEvent);
    }

    addSubmissionFormImg() {
        const formImg = document.querySelector(this.app.getSelector(".lead-submitted-img"));
        if (this.app.pmdrs.config.accountId == "delamomotorsports") {
            DOMHelper.addClass(formImg, 'd-none');
            return;
        }
        const pmDRSUrl = this.app.pmdrs.pmApi.getRootURL();
        let isMotosAmerica = this.app.pmdrs.isMotosAmericaSite();
        let isFCA = this.app.pmdrs.isFCA();
        let imgPath = "dist/img/giphy.webp"; // Default image
    
        if (this.app.isVehicleStellantis()) {//FCA
            imgPath = "dist/img/success2.webp";
        } else if (isMotosAmerica) {//MOTOS AMERICA
            if (this.app.isBMW()) {
                imgPath = "dist/img/MOTOS_BMW_SUBMIT2.webp";
            } else if (this.app.isVehicleDucati()) {
                imgPath = "dist/img/MOTOS_DUCATI_SUBMIT2.webp";
            } else if (this.app.isVehicleTriumph()) {
                imgPath = "dist/img/MOTOS_TRIUMPH_SUBMIT2.webp";
            }
        }else if (this.app.pmdrs.config.accountId == "sandiabmwmotorcycles"){//single site rule
            imgPath = "dist/img/SANDIA_BMW_SUBMIT2.webp";
        } else if (this.app.isVehiclePolaris()) {
            imgPath = "dist/img/PolarisGIF2.webp";
        } else if (this.app.isVehicleFord()) {
            imgPath = "dist/img/FordMustang.gif";
        } else if (this.app.isVehicleCanam()) {
            imgPath = "dist/img/canam2.png";
        } else if (this.app.isVehicleHarleyDavidson()) {
            imgPath = "dist/img/submit 2 370.gif";
        }
    
        formImg.dataset.src = pmDRSUrl + imgPath; // loaded when its modal opens (Modal.loadDeferredImages)
    }

    hideImage(){
        const noImageSites = ['fresnochryslerjeep', 'clovischryslerdodgejeepram', 'ironmountainjeep', 'escanabadodge', 'marinettedodge'];
        if(noImageSites.includes(this.app.pmdrs.config.accountId)){
            DOMHelper.addClass(this.app.getSelector(".lead-submitted-img"), 'd-none')
        }
    }
    

    updateSecondaryMessage(deposit) {
        let secondaryMessage = this.getSelector(".secondary-text");
        let message =
            "Thank you for submitting your deposit of $" +
            deposit +
            ". We have received your submission, and we'll be in touch really soon.";

        DOMHelper.setInnerHTML(secondaryMessage, message);
    }

    getHtml() {
        return `<div class="start-submission-modal">
    <p class="main-text">Your request was sent</p>
    <img class="lead-submitted-img" src="" alt="">
    <p class="secondary-text">The dealership will contact you about this vehicle using the contact method you selected.</p>
    <button id="submit-another-drs" class="d-none">Back to Dealer Site</button>
    <button id="close-form-submission">Continue</button>
</div>
`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }

    resetDrsForm() {
        let drsForm = document.querySelector(this.app.getSelector(".deal-page-form"));
        drsForm.reset();
        let formSubmission = this;

        // DealPage.stepper is permanently null (its real init is commented out,
        // DealPage.js:274-276 — a disabled/dead feature) — these two calls threw
        // unconditionally every time this ran, aborting the reset below before it
        // ever rebuilt a fresh DealPage. Confirmed via live testing, not assumed.

        formSubmission.app.dealPage = undefined;
        document.querySelector(".pm-speed-drs-v1.pmdrs-modals").innerHTML = "";
        formSubmission.app.dealModal = undefined;
        formSubmission.app.dealPage = new DealPage(formSubmission.app);
        var htmlElement = document.querySelector("html");
        formSubmission.app.dealModal = new Modal(
            formSubmission.app,
            "start-deal-modal",
            formSubmission.app.dealPage.getHtml(),
            null,
            "whole-screen"
        );
        formSubmission.app.dealModal.ariaLabel = formSubmission.app.getDealModalLabel();
        formSubmission.app.dealModal.setShowCallback(() => {
            htmlElement.classList.add("pmdrs-active");
        });

        formSubmission.app.dealModal.setHideCallback(() => {
            htmlElement.classList.remove("pmdrs-active");
        });
        formSubmission.app.dealModal.init();
        formSubmission.app.dealPage.init();
        // `-container` selectors are stale from before the tcpa-ccpa-descriptions.html markup
        // dropped its wrapper divs (see the current .tcpa-description/.ccpa-description labels,
        // ids #tcpa-description/#ccpa-description) — querySelector returned null here, throwing
        // and silently aborting the rest of resetDrsForm() on every Thank You modal close.
        document.querySelector(formSubmission.app.dealPage.getSelector("#tcpa-description")).style.display = "none";
        document.querySelector(formSubmission.app.dealPage.getSelector("#ccpa-description")).style.display = "none";
    }

    setBackground(make) {
        let background = "";
        if (make.toLowerCase() == "indian motorcycle") {
            background = "indian-background";
        } else {
            background = "bmw-background";
        }
        DOMHelper.addClass(this.getSelector("#close-form-submission"), background);
    }
}
